import { component } from 'picoapp';
import Drawer from '../../utils/drawer';
import Tabs from '../../utils/tabs';

export default component(async (node) => {
  /**
   * Data + elements
   */

  const parent = node.closest('ul');
  const drawerBtns = parent.querySelectorAll('.js-drawerBtn');

  /**
   * Functions
   */
  const initTabs = () => {
    const nodeHasTabs = node.dataset.hasTabs;

    if (nodeHasTabs === 'true' && nodeHasTabs !== null) {
      const wrapper = node.closest('div[product-info]');
      Tabs(wrapper, {
        tabBtnActiveClass: 'product__info__tab-button--active',
        tabActiveClass: 'product__info__tab--active',
      });
    }
  };

  const initDrawers = () => {
      const { index } = node.dataset;
      const drawerBtn = Array.from(drawerBtns).find((btn) => btn.dataset.index === index);
      const closeBtn = node.querySelector('.js-closeBtn');
      document.body.appendChild(node);
      const drawer = Drawer(node);

      drawerBtn.addEventListener('click', () => drawer.open());
      closeBtn.addEventListener('click', () => drawer.close());
  };

  const init = () => {
    initTabs();
    initDrawers();
  };

  /**
   * Init
   */
  init();
});
